import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaPlus, FaDollarSign, FaBoxOpen, FaTimes } from 'react-icons/fa';
import UserContext from './UserContext';
import HttpInterceptor from '../lib/HttpInterceptor';

const QuickActions = () => {
  const navigate = useNavigate();
  const { session } = useContext(UserContext);
  const [isReseller, setIsReseller] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const checkResellerStatus = async () => {
      if (!session?.id) return;
      try {
        const response = await HttpInterceptor.get('/api/resellers/profile');
        if (response.data?.success && response.data?.data?.status === 'approved') {
          setIsReseller(true);
        }
      } catch (error) {
        setIsReseller(false);
      }
    };
    checkResellerStatus();
  }, [session?.id]);

  if (!session?.id || !isReseller) return null;

  const actions = [
    {
      icon: <FaPlus />,
      label: 'Add Product',
      onClick: () => navigate('/reseller/products'),
      color: 'bg-purple-600 hover:bg-purple-700'
    },
    {
      icon: <FaBoxOpen />,
      label: 'View Orders',
      onClick: () => navigate('/reseller/orders'),
      color: 'bg-blue-600 hover:bg-blue-700'
    },
    {
      icon: <FaDollarSign />,
      label: 'Earnings',
      onClick: () => navigate('/reseller/earnings'),
      color: 'bg-green-600 hover:bg-green-700'
    }
  ];

  return (
    <div className="fixed bottom-20 right-4 md:bottom-6 md:right-6 z-40">
      {isOpen ? (
        <div className="bg-white rounded-xl shadow-2xl p-4 mb-4 border border-gray-200">
          <div className="flex justify-between items-center mb-3">
            <h3 className="font-semibold text-gray-800">Quick Actions</h3>
            <button
              onClick={() => setIsOpen(false)}
              className="text-gray-500 hover:text-gray-700"
              aria-label="Close quick actions"
            >
              <FaTimes />
            </button>
          </div>
          <div className="space-y-2">
            {actions.map((action, index) => (
              <button
                key={index}
                onClick={() => {
                  action.onClick();
                  setIsOpen(false);
                }}
                className={`w-full ${action.color} text-white px-4 py-2 rounded-lg flex items-center gap-2 font-medium transition-colors`}
              >
                {action.icon}
                <span>{action.label}</span>
              </button>
            ))}
          </div>
        </div>
      ) : null}
      
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`${isOpen ? 'bg-gray-600' : 'bg-purple-600'} text-white p-4 rounded-full shadow-lg hover:bg-purple-700 transition-all focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2`}
        aria-label="Toggle quick actions"
      >
        <FaPlus className={`text-xl transition-transform ${isOpen ? 'rotate-45' : ''}`} />
      </button>
    </div>
  );
};

export default QuickActions;

